import { useQuery } from '@tanstack/react-query'
import { checkDuplicateSmokerRateOverrideRule } from '../../../api/plan-smoker-rate-override-rules-api'
import type { CheckDuplicateSmokerRateOverrideRuleQueryDto } from '../../../api/dto/plan-smoker-rate-override-rules.dto'

export const SMOKER_RATE_OVERRIDE_CHECK_DUPLICATE_QUERY_KEY =
  'smokerRateOverrideCheckDuplicate'

export function useCheckDuplicateSmokerRateOverrideRule(
  query: Partial<CheckDuplicateSmokerRateOverrideRuleQueryDto>,
  enabled: boolean
) {
  return useQuery({
    queryKey: [SMOKER_RATE_OVERRIDE_CHECK_DUPLICATE_QUERY_KEY, query],
    queryFn: () =>
      checkDuplicateSmokerRateOverrideRule(
        query as CheckDuplicateSmokerRateOverrideRuleQueryDto
      ),
    enabled,
    staleTime: 10_000,
  })
}
